import SubmissionModel from "@/models/lab/SubmissionModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

/**
 * Submission collection
 */
export default class SubmissionCollection extends LabServiceCollection {

  // Model that is contained in this collection.
  model() {
    return SubmissionModel;
  }

}
